import { defineNuxtRouteMiddleware } from '#imports'
import { createNavigationGuard } from '@router/navigation-guard'
import { asRouteMiddleware } from '@router/route-guards'

// Global middleware runs before a route's own, as the router's global guard ran before
// `beforeEnter`: it has to remember a signed-out visitor's destination before `auth`
// sends them to login. It also runs on the first page load, unlike a guard added from
// a plugin.
export default defineNuxtRouteMiddleware(asRouteMiddleware(createNavigationGuard()))
